import {
  type HubWorkflow,
  HubWorkflowStatus,
} from '@robovision/hub'
import { WorkflowTask } from './WorkflowTask'


export interface WorkflowParams {
  completedAt?: Date
  createdAt: Date
  id: string
  name: string
  projectId?: string
  status: HubWorkflowStatus
  statusMessage?: string
  tags: string[]
  tasks: WorkflowTask[]
}

export class Workflow {
  public completedAt?: Date
  public createdAt: Date
  public id: string
  public name: string
  public projectId?: string
  public status: HubWorkflowStatus
  public statusMessage?: string
  public tags: string[]
  public tasks: WorkflowTask[]

  constructor (params: WorkflowParams) {
    this.completedAt = params.completedAt
    this.createdAt = params.createdAt
    this.id = params.id
    this.name = params.name
    this.projectId = params.projectId
    this.status = params.status
    this.statusMessage = params.statusMessage
    this.tags = params.tags
    this.tasks = params.tasks
  }

  public get isFinished () {
    return this.status === HubWorkflowStatus.DONE ||
      this.status === HubWorkflowStatus.FAILED ||
      this.status === HubWorkflowStatus.STOPPED
  }

  public get isSuccess () {
    return this.status === HubWorkflowStatus.DONE ||
    this.status === HubWorkflowStatus.STOPPED
  }

  public get isStopping () {
    return this.status === HubWorkflowStatus.STOPPING
  }

  public get isStopped () {
    return this.status === HubWorkflowStatus.STOPPED
  }

  public get isFailed () {
    return this.status === HubWorkflowStatus.FAILED
  }

  public get isRunning () {
    return this.status === HubWorkflowStatus.RUNNING
  }

  public get isQueued () {
    return this.status === HubWorkflowStatus.QUEUED
  }

  public get isInProgress () {
    return (
      this.status === HubWorkflowStatus.RUNNING ||
      this.status === HubWorkflowStatus.QUEUED ||
      this.status === HubWorkflowStatus.STARTING
    )
  }

  static fromResponse (response: HubWorkflow): Workflow {
    // we assume here the tasks in the workflow are returned in order
    // i.e. all dependencies of a tasks are artifacts of previous tasks
    // otherwise we'll bail out
    // we could compute the dependency graph here but I can't be bothered
    const tasks: WorkflowTask[] = []
    for (const task of response.tasks) {
      tasks.push(WorkflowTask.fromResponse(task, tasks))
    }

    return new Workflow({
      completedAt: response.completedAt ? new Date(response.completedAt) : undefined,
      createdAt: new Date(response.createdAt),
      id: response.id,
      name: response.name,
      projectId: response.projectId,
      status: response.status,
      statusMessage: response.statusMessage,
      tags: response.tags,
      tasks,
    })
  }
}
